module.exports = __webpack_public_path__ + "static/media/location_id.d504c959.jpg";